export default __webpack_public_path__ + "static/media/AI Concierge.153c4103.svg";